import React from 'react';
import '../../css/Admin.css';
import { AvailableRoutes } from '../../AppRoutes';
import { Redirect } from 'react-router-dom';

const Notifications = (): JSX.Element => {
    return <Redirect to={AvailableRoutes.emailNotifications} />;
};

export default Notifications;
